<template lang='pug'>
  v-card-text
    v-timeline(align-top dense)
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col(cols="6") Drag primary controls to change the overall form of a body section
          v-col
            v-img(src='/day6-workflow/editor-pose-control.svg' max-width='128')
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col(cols="6") Double click a primary control to toggle secondary controls for finer pose control
          v-col
            v-img(src='/day6-workflow/tune-pose-section.png' max-width='128')
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col Fix pose to body options move the pose section with the body center
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col
            v-btn.mx-4(outlined fab small color='accent')
              v-icon share
            | copies a link for sharing the posed character
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col
            v-btn.mx-4(outlined fab small color='accent')
              v-icon {{mdiHuman}}
            | opens&nbsp;
            a.accent--text(@click.prevent="$emit('show-info-generate')") Character Modeling
</template>

<script>
import { mdiHuman } from '@mdi/js'

export default {
  name: 'Day6InfoPose',
  data: () => ({
    mdiHuman
  })
}
</script>
